import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import './css/header.css';

const menuItems = [
    { label: 'Home', path: '/' },
    { label: 'About Us', path: '/about' },
    { label: 'Tax Services', path: '/tax-services' },
    { label: 'Accounting Services', path: '/accounting-services' },
    { label: 'Contact Us', path: '/contact' },
];

export default function Header() {
    const [isOpen, setIsOpen] = useState(false);

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };

    const closeMenu = () => {
        setIsOpen(false);
    };

    return (
        <nav className={`menu ${isOpen ? 'active' : ''}`}>
            <div className="menu-header-row">
                <NavLink className="menu-brand" to="/" onClick={closeMenu}>
                    TAXOBEY
                </NavLink>
                <button
                    onClick={toggleMenu}
                    className="menu-toggle"
                    type="button"
                    aria-label="Toggle navigation"
                    aria-expanded={isOpen}
                    aria-controls="site-navigation"
                >
                    ☰
                </button>
            </div>
            <ul className="menu-list" id="site-navigation">
                {menuItems.map((item) => (
                    <li key={item.path}>
                        <NavLink
                            className={({ isActive }) => `menu-item${isActive ? ' active' : ''}`}
                            onClick={closeMenu}
                            to={item.path}
                            end={item.path === '/'}
                        >
                            {item.label}
                        </NavLink>
                    </li>
                ))}
            </ul>
        </nav>
    );
}